import { axiosController } from '@/lib/network';
import { UseQueryOptions, useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { Result } from '@/lib/type';

export type MetaAddonsType = {
  ID: string;
  Background: string;
  Avatar: string;
  Title: string;
  Description: string;
  Amount?: string;
  IsOfficial?: boolean;
  Categories?: string[];
  BannerImageList?: string[];
  Announcement?: string[];
  WorkspaceAvatar?: string;
  Subtitle?: string;
};

export type UseAddonsMetaReturnType = Result<{
  AddonsList: MetaAddonsType[];
  RequestAddons: MetaAddonsType[];
}>;

export const useAddonsMeta = <T = UseAddonsMetaReturnType['Result']>(
  opt?: UseQueryOptions<UseAddonsMetaReturnType['Result'], AxiosError, T, string[]>
) => {
  return useQuery({
    ...opt,
    queryKey: ['addons', 'meta'],
    queryFn: async () => {
      const res = await axiosController.get<UseAddonsMetaReturnType>('/v2/addons/meta');
      return res.data.Result;
    },
  });
};
